export default "__VITE_ASSET__C$L1vOFg__"